module.exports = function () {
  var v13890 = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || null;
  var v13891 = window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || null;
  function f2145(p17778, p17779) {
    var vA783 = [];
    Object.keys(p17779).forEach(function (p17780) {
      if (p17779[p17780] === p17778) {
        vA783.push(p17780);
      } else if (Array.isArray(p17779[p17780]) && p17779[p17780].indexOf(p17778) !== -1) {
        vA783.push(p17780);
      }
    });
    return vA783;
  }
  this._connected = false;
  this.active = false;
  this.idleTime = 300000;
  this._gamepad = null;
  this.disabled = false;
  this._events = {
    gamepad: {},
    axes: {}
  };
  this._keyMapping = {
    gamepad: {
      button_1: 0,
      button_2: 1,
      button_3: 2,
      button_4: 3,
      shoulder_top_left: 4,
      shoulder_top_right: 5,
      shoulder_bottom_left: 6,
      shoulder_bottom_right: 7,
      select: 8,
      start: 9,
      stick_button_left: 10,
      stick_button_right: 11,
      d_pad_up: 12,
      d_pad_down: 13,
      d_pad_left: 14,
      d_pad_right: 15,
      vendor: 16
    },
    axes: {
      stick_axis_left: [0, 2],
      stick_axis_right: [2, 4]
    }
  };
  this._threshold = 0.3;
  this._listeners = [];
  var vThis141 = this;
  this._handleGamepadConnected = p17781 => {
    if (!vThis141.disabled) {
      if (!vThis141._connected) {
        vThis141._connected = true;
        vThis141.active = true;
        vThis141._gamepad = p17781.gamepad;
        vThis141._events.gamepad = {};
        vThis141._events.axes = {};
        vThis141._handleGamepadEventListener(p17781.gamepad);
        vThis141._handleGamepadAxisEventListener(p17781.gamepad);
        vThis141._requestAnimation = v13890(vThis141._loop.bind(vThis141));
      }
    }
  };
  this._handleGamepadDisconnected = () => {
    v13891(vThis141._requestAnimation);
    vThis141._requestAnimation = null;
    vThis141._connected = false;
    vThis141._events.gamepad = null;
    vThis141._events.axes = null;
    vThis141._gamepad = null;
    vThis141.active = false;
  };
  this._handleGamepadEventListener = p17782 => {
    if (!vThis141.disabled) {
      var vVThis141 = vThis141;
      if (p17782 && p17782.connected) {
        p17782.buttons.forEach(function (p17783, p17784) {
          var vF2145 = f2145(p17784, vVThis141._keyMapping.gamepad);
          if (vF2145) {
            vF2145.forEach(function (p17785) {
              if (p17783.pressed) {
                if (!vVThis141._events.gamepad[p17785]) {
                  vVThis141._events.gamepad[p17785] = {
                    pressed: true,
                    hold: false,
                    released: false
                  };
                }
                vVThis141._events.gamepad[p17785].value = p17783.value;
              } else if (!p17783.pressed && vVThis141._events.gamepad[p17785]) {
                vVThis141._events.gamepad[p17785].released = true;
                vVThis141._events.gamepad[p17785].hold = false;
              }
            });
          }
        });
      }
    }
  };
  this._handleGamepadAxisEventListener = p17786 => {
    if (!vThis141.disabled) {
      var vVThis1412 = vThis141;
      if (p17786 && p17786.connected) {
        Object.keys(vThis141._keyMapping.axes).forEach(function (p17787) {
          var v13892 = Array.prototype.slice.apply(p17786.axes, vVThis1412._keyMapping.axes[p17787]);
          if (Math.abs(v13892[0]) > vVThis1412._threshold || Math.abs(v13892[1]) > vVThis1412._threshold) {
            vVThis1412._events.axes[p17787] = {
              pressed: !vVThis1412._events.axes[p17787],
              hold: !!vVThis1412._events.axes[p17787],
              released: false,
              value: v13892
            };
          } else if (vVThis1412._events.axes[p17787]) {
            vVThis1412._events.axes[p17787] = {
              pressed: false,
              hold: false,
              released: true,
              value: v13892
            };
          }
        });
      }
    }
  };
  this._handleEvent = (p17788, p17789) => {
    if (!vThis141.disabled) {
      vThis141.active = true;
      if (p17789[p17788].pressed) {
        vThis141.trigger("press", p17788, p17789[p17788].value);
        p17789[p17788].pressed = false;
        p17789[p17788].hold = true;
      } else if (p17789[p17788].hold) {
        vThis141.trigger("hold", p17788, p17789[p17788].value);
      } else if (p17789[p17788].released) {
        vThis141.trigger("release", p17788, p17789[p17788].value);
        delete p17789[p17788];
      }
    }
  };
  this._loop = () => {
    if (!vThis141.disabled) {
      var v13893 = navigator.getGamepads ? navigator.getGamepads() : navigator.webkitGetGamepads ? navigator.webkitGetGamepads : [];
      if (!v13893) {
        return vThis141._handleGamepadDisconnected();
      }
      vThis141._gamepad = v13893[0];
      if (vThis141.active && Date.now() - vThis141.lastActive >= vThis141.idleTime) {
        vThis141.active = false;
      }
      if (v13893[0] && v13893[0].connected) {
        vThis141._handleGamepadEventListener(v13893[0]);
        vThis141._handleGamepadAxisEventListener(v13893[0]);
      }
      if (vThis141._events.gamepad) {
        Object.keys(vThis141._events.gamepad).forEach(function (p17790) {
          vThis141._handleEvent(p17790, vThis141._events.gamepad);
        });
      }
      if (vThis141._events.axes) {
        Object.keys(vThis141._events.axes).forEach(function (p17791) {
          vThis141._handleEvent(p17791, vThis141._events.axes);
        });
      }
      if (vThis141._requestAnimation) {
        vThis141._requestAnimation = v13890(vThis141._loop.bind(vThis141));
      }
    }
  };
  this.on = (p17792, p17793, p17794, p17795) => {
    if (typeof p17792 == "string" && p17792.match(/\s+/)) {
      p17792 = p17792.split(/\s+/g);
    }
    if (typeof p17793 == "string" && p17793.match(/\s+/)) {
      p17793 = p17793.split(/\s+/g);
    }
    if (Array.isArray(p17792)) {
      p17792.forEach(function (p17796) {
        vThis141.on(p17796, p17793, p17794, p17795);
      });
    } else if (Array.isArray(p17793)) {
      p17793.forEach(function (p17797) {
        vThis141.on(p17792, p17797, p17794, p17795);
      });
    } else {
      vThis141._listeners.push({
        type: p17792,
        button: p17793,
        callback: p17794,
        options: p17795,
        rumble: vThis141.rumble
      });
    }
  };
  this.off = (p17798, p17799) => {
    if (typeof p17798 == "string" && p17798.match(/\s+/)) {
      p17798 = p17798.split(/\s+/g);
    }
    if (typeof p17799 == "string" && p17799.match(/\s+/)) {
      p17799 = p17799.split(/\s+/g);
    }
    if (Array.isArray(p17798)) {
      p17798.forEach(function (p17800) {
        vThis141.off(p17800, p17799);
      });
    } else if (Array.isArray(p17799)) {
      p17799.forEach(function (p17801) {
        vThis141.off(p17798, p17801);
      });
    } else {
      vThis141._listeners = vThis141._listeners.filter(function (p17802) {
        return p17802.type !== p17798 && p17802.button !== p17799;
      });
    }
  };
  this.trigger = (p17803, p17804, p17805) => {
    if (!vThis141.disabled) {
      if (vThis141._listeners) {
        vThis141._listeners.forEach(function (p17806) {
          if (p17806.type === p17803 && p17806.button === p17804) {
            p17806.callback({
              type: p17806.type,
              button: p17806.button,
              value: p17805,
              event: p17806,
              timestamp: Date.now()
            });
          }
        });
      }
    }
  };
  this.rumble = function (p17807, p17808) {
    if (!vThis141.disabled) {
      if (vThis141._gamepad && vThis141._gamepad.vibrationActuator && vThis141._gamepad.vibrationActuator.type == "dual-rumble" && vThis141._gamepad.vibrationActuator.playEffect) {
        vThis141._gamepad.vibrationActuator.playEffect("dual-rumble", {
          startDelay: 0,
          duration: p17807 || 200,
          weakMagnitude: (p17808 || 0.5) * 0.5,
          strongMagnitude: p17808 || 0.5
        });
      }
    }
  };
  window.addEventListener("MozGamepadConnected", this._handleGamepadConnected, false);
  window.addEventListener("MozGamepadDisconnected", this._handleGamepadDisconnected, false);
  window.addEventListener("gamepadconnected", this._handleGamepadConnected, false);
  window.addEventListener("gamepaddisconnected", this._handleGamepadDisconnected, false);
};